import { graphql } from '../../__generated__';

export const GET_SPREAD_PERCENTAGE = graphql(`
  query OmsSpreadByAssetId($assetId: Int!) {
    omsSpreadByAssetId(assetId: $assetId) {
      percentageDifference
    }
  }
`);
